import { config } from '@/config';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { useSelector } from 'react-redux';

const useGenerateCheckoutEditorLink = () => {
  const isSkip = useSelector(isSkipApiSelector);
  const { data: profileIdRes } = apiCaller.useGetCheckoutProfileIdQuery(undefined, { skip: isSkip });

  const baseLink = `https://admin.shopify.com/store/${config.shop?.replace(
    '.myshopify.com',
    '',
  )}/settings/checkout/editor/profiles/${profileIdRes?.data?.id}`;

  return {
    link: `${baseLink}?page=checkout`,
    linkThankYou: `${baseLink}?page=thank-you`,
    isHasId: profileIdRes?.data?.id,
  };
};

export default useGenerateCheckoutEditorLink;
